import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock, Hourglass, Flame, TrendingUp, TrendingDown, AlertCircle } from "lucide-react";
import { api, eur, fmtDate, slotLabel } from "@/lib/api";
import { SERVICES, STATUS } from "@/lib/brand";
import { Card, Empty, PageHead, Pill, StatCard } from "@/components/common";

const BookingRow = ({ b }) => (
  <div className="flex items-start justify-between gap-3 py-4 border-b border-[#E2DDD5] last:border-0">
    <div>
      <p className="font-semibold text-[#0D3B52]">{fmtDate(b.date)} · {slotLabel(b.slot_start)}</p>
      <p className="text-sm text-[#5C6B73]">{b.vet_name || b.owner_name} · {b.pet_name || b.species} · {SERVICES[b.service_type]}</p>
      <p className="text-xs text-[#5C6B73]">{b.pickup_address} {b.city}</p>
    </div>
    <Pill cls={STATUS[b.status]?.cls}>{STATUS[b.status]?.label}</Pill>
  </div>
);

export default function Overview() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="text-sm text-[#5C6B73]">Caricamento…</p>;
  return (
    <div data-testid="admin-overview">
      <PageHead eyebrow="Panoramica" title="Buongiorno" subtitle={`Oggi è ${fmtDate(s.today)}. Ecco la situazione dell'agenzia.`} />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Ritiri oggi" value={s.today_bookings.length} icon={CalendarClock} testid="stat-today" />
        <StatCard label="Da confermare" value={s.pending_count} icon={Hourglass} tone="gold" testid="stat-pending" />
        <StatCard label="Entrate del mese" value={eur(s.entrate_mese)} icon={TrendingUp} testid="stat-entrate" />
        <StatCard label="Uscite del mese" value={eur(s.uscite_mese)} icon={TrendingDown} tone="gold" testid="stat-uscite" />
        <StatCard label="Pratiche del mese" value={s.pratiche_mese} icon={Flame} testid="stat-pratiche" />
        <StatCard label="Da incassare" value={eur(s.residuo_totale)} icon={AlertCircle} tone="gold" testid="stat-residuo" />
      </div>
      <div className="grid lg:grid-cols-2 gap-6 mt-8">
        <Card className="p-6">
          <div className="flex items-center justify-between mb-2">
            <h2 className="font-display text-2xl font-semibold text-[#0D3B52]">Giro di oggi</h2>
            <Link to="/admin/agenda" className="text-sm text-[#997316] font-semibold" data-testid="overview-agenda-link">Agenda →</Link>
          </div>
          {s.today_bookings.length ? s.today_bookings.map((b) => <BookingRow key={b.id} b={b} />) : <Empty>Nessun ritiro per oggi.</Empty>}
        </Card>
        <Card className="p-6">
          <h2 className="font-display text-2xl font-semibold text-[#0D3B52] mb-2">Prossimi ritiri</h2>
          {s.upcoming.length ? s.upcoming.map((b) => <BookingRow key={b.id} b={b} />) : <Empty>Nessun ritiro in programma.</Empty>}
        </Card>
      </div>
    </div>
  );
}
